import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { adminApi } from "@/lib/adminApi";
import { useSite } from "@/lib/content";
import { setRobots } from "@/lib/seo";
import { setLang } from "@/lib/i18n";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

export default function Admin() {
  setLang("tr");
  const [user, setUser] = useState(null);
  const { reload } = useSite();

  useEffect(() => {
    document.title = "Yönetim | Woodia Polonez";
    setRobots(true);
    adminApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const onLogin = (u) => {
    setUser(u);
    reload();
  };
  const onLogout = async () => {
    await adminApi.post("/auth/logout").catch(() => null);
    setUser(false);
    reload();
  };

  return (
    <div className="min-h-screen bg-cream-2" data-testid="admin-root">
      {user === null && <div className="min-h-screen" aria-busy="true" />}
      {user === false && <AdminLogin onLogin={onLogin} />}
      {user && user.role === "admin" && <AdminDashboard user={user} onLogout={onLogout} />}
      {user && user.role !== "admin" && (
        <main className="min-h-screen flex items-center justify-center px-4" data-testid="admin-staff-denied">
          <div className="max-w-sm rounded-3xl bg-white border border-line p-8 space-y-4 text-center">
            <h1 className="text-2xl font-semibold text-forest">Bu alana erişim yetkiniz yok</h1>
            <p className="text-sm text-ink-muted">Görevli hesapları yalnızca giriş terminalini kullanabilir.</p>
            <a href="/terminal" className="inline-flex min-h-[48px] items-center px-6 rounded-full bg-forest text-cream font-semibold" data-testid="admin-staff-terminal-link">Terminale git</a>
            <button type="button" onClick={onLogout} className="block mx-auto text-sm underline" data-testid="admin-staff-logout">Çıkış yap</button>
          </div>
        </main>
      )}
      <Toaster position="top-center" richColors />
    </div>
  );
}
